/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.CopyPattern.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CopyPattern.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.patternItems = [];
  this.choicesItems = [];
  this.dropZoneItems = [];
  this.emptyFrames = [];
  this.shuffledChoices = [];
  this.instructions = null;
};

EDC.Games.CopyPattern.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CopyPattern.Scenes.Main.prototype.constructor = EDC.Games.CopyPattern.Scenes.Main;

const MTP = EDC.Games.CopyPattern.Scenes.Main.prototype;

MTP.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

MTP.loadIteration = function () {
  this.addPattern();
  this.addChoices(false);
  this.addEmptyFrames();
};

MTP.nextIteration = function () {
  this.patternItems.map((x) => {
    x.destroy();
    return true;
  });
  this.patternItems = [];
  this.dropZoneItems.map((x) => {
    x.destroy();
    return true;
  });
  this.dropZoneItems = [];
  this.choicesItems.map((x) => {
    x.destroy();
    return true;
  });
  this.choicesItems = [];
  this.emptyFrames.map((x) => {
    x.destroy();
    return true;
  });
  this.emptyFrames = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
    this.instructions.setVisible(true);
  }
};

MTP.createTemplateUI = function () {
  const title = this.add.sprite(940, 90, 'title');
  const highlight = this.add.sprite(0, 0, 'highlight');
  const border = this.add.sprite(1050, 750, 'border');
  highlight.displayWidth = border.displayWidth;
  highlight.displayHeight = border.displayHeight;
  highlight.x = border.x;
  highlight.y = border.y;
  const instructions = this.add.sprite(border.x, border.y + 10, 'instructions').setDepth(1);
  this.instructions = instructions;
  const choicesHighlight = this.add
    .sprite(130, 570, 'highlight')
    .setOrigin(0.5)
    .setAngle(90);
  choicesHighlight.displayWidth = 780;
  choicesHighlight.displayHeight = 170;
};

MTP.addEmptyFrames = function () {
  const { answer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const startingX = this.patternItems[0].x;
  for (let i = 0; i < answer.length; i++) {
    const empty = this.add.sprite(0, 750, 'empty-frame').setScale(0.85);
    this.emptyFrames.push(empty);
  }
  this.adjustPosition(this.emptyFrames);
};

MTP.adjustPosition = function (array) {
  const width = array.length * array[0].displayWidth;
  const startingX = (this.game.config.width - width) / 2 + 130;
  for (let i = 0; i < array.length; i++) {
    array[i].x = startingX + (array[0].displayWidth + 30) * i;
    array[i].init_X = array[i].x;
  }
};

MTP.adjustChoicesPosition = function (array) {
  for (let i = 0; i < array.length; i++) {
    array[i].x = 132;
    array[i].y = 250 + i * 128;
    array[i].init_Y = array[i].y;
  }
};

MTP.addChoices = function (isRepeating) {
  const { answer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const choicesCount = this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices;
  const random = [];
  // add possible answers
  for (let i = 0; i < answer.length; i++) {
    if (random.indexOf(answer[i]) === -1) {
      random.push(answer[i]);
    }
  }
  // fill array without duplicates untill choices count is reached
  const neededAssets = choicesCount - random.length;
  for (let i = 0; i < neededAssets; i++) {
    const randomAsset = Math.floor(Math.random() * this.gameConfig.assets.length);
    if (random.indexOf(randomAsset) === -1) {
      random.push(randomAsset);
    } else {
      i -= 1;
    }
  }
  if (!isRepeating) {
    this.shuffledChoices = this.shuffleChoices(random);
  }
  for (let i = 0; i < this.shuffledChoices.length; i++) {
    const item = this.add
      .sprite(0, 0, `asset-${this.shuffledChoices[i]}`)
      .setOrigin(0.5)
      .setScale(0.55);
    item.id = this.shuffledChoices[i];
    this.generateDataForShake(item);
    item.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(item);
    this.input.setDraggable(item);
    item.on(
      'drag',
      ((sprite, pointer, x, y) => {
        sprite.setPosition(x, y);
      }).bind(this, item),
    );
    item.on('dragend', this.onDragStop.bind(this, item), this);
    item.on('dragstart', this.onDragstart.bind(this, item), this);
    this.choicesItems.push(item);
  }
  this.adjustChoicesPosition(this.choicesItems);
};

MTP.createNewItem = function (item) {
  const newItem = this.add
    .sprite(-500, item.init_Y, `asset-${item.id}`)
    .setOrigin(0.5)
    .setScale(0.55);
  newItem.init_Y = newItem.y;
  newItem.id = item.id;
  this.generateDataForShake(newItem);
  newItem.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(newItem);
  this.input.setDraggable(newItem);
  newItem.on(
    'drag',
    ((sprite, pointer, x, y) => {
      sprite.setPosition(x, y);
    }).bind(this, newItem),
  );
  newItem.on('dragend', this.onDragStop.bind(this, newItem), this);
  newItem.on('dragstart', this.onDragstart.bind(this, newItem), this);
  this.choicesItems.push(newItem);
  this.tweens.add({
    targets: newItem,
    x: 132,
    y: item.init_Y,
    duration: 500,
    ease: 'Sine.easeInOut',
  });
};

MTP.onDragstart = function (dragObj) {
  dragObj.setDepth(2);
  dragObj.scaleAnim = this.tweens.add({
    targets: dragObj,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 200,
    ease: 'Linear',
  });
  this.tweens.killTweensOf(dragObj);
  dragObj.angle = 0;
};

MTP.onDragStop = function (dragObj) {
  dragObj.setDepth(0);
  if (dragObj.y > 650 && dragObj.x > 250) {
    this.createNewItem(dragObj);
    dragObj.disableInteractive();
    this.instructions.setVisible(false);
    this.addOnDropZone(dragObj);
  } else {
    dragObj.scaleAnim.stop();
    dragObj.setScale(0.55);
    dragObj.x = 132;
    dragObj.y = dragObj.init_Y;
    this.generateDataForShake(dragObj);
  }
};

MTP.shuffleChoices = function (choices) {
  let j; let x; let i;
  for (i = choices.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = choices[i];
    choices[i] = choices[j];
    choices[j] = x;
  }
  return choices;
};

MTP.addPattern = function () {
  const pattern = this.gameConfig.sets[this.difficulty].iterations[this.iteration].pattern;
  for (let i = 0; i < pattern.length; i++) {
    const item = this.add.sprite(0, 400, `asset-${pattern[i]}`);
    item.id = pattern[i];
    item.displayWidth = 200;
    item.displayHeight = 200;
    this.patternItems.push(item);
  }
  this.adjustPosition(this.patternItems);
  this.highlightAnim();
};

MTP.highlightAnim = function () {
  for (let i = 0; i < this.patternItems.length; i++) {
    this.time.addEvent({
      delay: 300 + i * 250,
      callback: this.highlight,
      args: [this.patternItems[i]],
      callbackScope: this,
    });
  }
};

MTP.addOnDropZone = function (dragObj) {
  this.dropZoneItems.push(dragObj);
  this.dropZoneItems[this.dropZoneItems.length - 1].y = this.emptyFrames[this.dropZoneItems.length - 1].y;
  this.dropZoneItems[this.dropZoneItems.length - 1].x = this.emptyFrames[this.dropZoneItems.length - 1].x;
  this.checkAnswer(dragObj);
};

MTP.checkAnswer = function (dragObj) {
  const { answer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const lastItemIndex = this.dropZoneItems.length - 1;
  const correctAnswer = answer[lastItemIndex];
  this.emptyFrames[lastItemIndex].setVisible(false);
  if (dragObj.id === correctAnswer) {
    if (this.dropZoneItems.length === answer.length) {
      this.playCorrect();
      this.choicesItems.map((x) => {
        x.disableInteractive();
        x.shakeAnim.stop();
        return true;
      });
      this.time.delayedCall(2000, this.nextIteration, [], this);
    }
  } else {
    this.playWrong();
    this.choicesItems.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      return true;
    });
    this.wrongAnimation();
  }
};

MTP.wrongAnimation = function () {
  for (let i = 0; i < this.dropZoneItems.length; i++) {
    this.dropZoneItems[i].setTint(0xff0000);
    this.tweens.add({
      targets: this.dropZoneItems[i],
      y: this.dropZoneItems[i].y + 30,
      duration: 150,
      ease: 'Linear',
      delay: 300,
      onComplete: this.goUp.bind(this),
    });
  }
};

MTP.goUp = function () {
  for (let i = 0; i < this.dropZoneItems.length; i++) {
    this.tweens.add({
      targets: this.dropZoneItems[i],
      y: -200,
      duration: 750,
      ease: 'Linear',
      onComplete: this.startOver.bind(this),
    });
  }
};

MTP.startOver = function () {
  this.dropZoneItems.map((x) => {
    x.destroy();
    return true;
  });
  this.dropZoneItems = [];
  this.choicesItems.map((x) => {
    x.destroy();
    return true;
  });
  this.choicesItems = [];
  this.emptyFrames.map((x) => {
    x.setVisible(true);
    return true;
  });
  this.instructions.setVisible(true);
  this.addChoices(true);
};

MTP.generateDataForShake = function (item) {
  item.shakeAnim = this.tweens.add({
    targets: item,
    angle: item.angle - 6,
    duration: 90,
    ease: 'Sine.easeInOut',
    repeat: 4,
    delay: 5000,
    yoyo: true,
    onComplete: this.generateDataForShake.bind(this, item),
  });
};

MTP.highlightItem = function (item) {
  item.clearTint();
  if (item) {
    this.time.addEvent({
      delay: 7000, callback: this.highlight, args: [item], callbackScope: this,
    });
  }
};

MTP.highlight = function (item) {
  item.setTint(0x0ffff0);
  this.tweens.add({
    targets: item,
    scaleX: 1.1,
    scaleY: 1.1,
    ease: 'Linear',
    duration: 300,
    yoyo: true,
    onComplete: this.highlightItem.bind(this, item),
  });
};

export default EDC.Games.CopyPattern.Scenes.Main;
